export default __webpack_public_path__ + "static/media/media-img-3.c8ee181d.png";